import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Initialize i18next with no resources; LanguageProvider will load JSON bundles dynamically.
i18n
    .use(initReactI18next)
    .init({
        resources: {},
        lng: 'en',
        fallbackLng: 'en',
        interpolation: {
            escapeValue: false,
        },
        react: {
            useSuspense: false,
        },
    });

export default i18n;
